import React from "react";
import Slider from "react-slick";
import {
  gondoor,
  freshZone,
  stringer,
  spacecoin,
  warrantyNinja,
  infiiot,
} from "./imports";
import "./Portfollio.css";

const Portfollio = () => (
  <div>
    <div id="portfolio"></div>
    <section
      className="scrobits__brand"
      // id="portfolio"
      data-aos="zoom-in"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div>
        {" "}
        <h1 className="gradient__text">
          {" "}
          We’re proud to have worked on amazing projects.{" "}
        </h1>
      </div>
      <div>
        {/* <marquee behavior="scroll" direction="right" scrollamount="50"> */}
        {/* <Slider {...settings}> */}
        <div>
          <img
            className="portfolio-logo"
            src={stringer}
            alt="stringer app icon"
          />
        </div>
        <div>
          <img
            // className="portfolio-logo"
            src={freshZone}
            alt="fresh zone app icon "
          />
        </div>
        <div>
          <img
            className="portfolio-logo"
            src={infiiot}
            alt="infiiot app icon"
          />
        </div>
        <div>
          <img
            className="portfolio-logo"
            src={spacecoin}
            alt="spacecoin app icon "
          />
        </div>
        <div>
          <img
            className="portfolio-logo"
            src="https://profilesketch.com/static/media/Logo.b5853900.png"
            alt="profilesketch icon"
          />
        </div>
        <div>
          <img
            className="portfolio-logo"
            src={warrantyNinja}
            alt="warrantyNinja icon "
          />
        </div>
        <div>
          <img
            // className="portfolio-logo"
            src={gondoor}
            alt="gondoor app icon"
          />
        </div>
        <div>
          <img
            className="portfolio-logo"
            src="https://synthomaxxindia.com/img/svg/Untitled%20design(3).png"
            alt="synthomaxxindia icon "
          />
        </div>

        {/* <div>
          <img
            className="portfolio-logo"
            src="https://shiventerprisesco.com/images/logo.jpg"
            alt="gron door app icon"
          />
        </div> */}
        {/* </Slider> */}
      </div>
      <p className="portfolio-many-more">And many more...</p>
      {/* </marquee> */}
    </section>
  </div>
);

export default Portfollio;
